import { useMemo } from 'react';
import { streem } from 'streem-sdk-protobuf';

type ReservationBannerHandlerReturn = {
    shouldShowBanner: boolean;
    shouldClearBanner: boolean;
};

const GroupReservationStatus = streem.api.GroupReservationStatus;

export const useReservationBannerHandler = (
    isReserved: boolean,
    groupReservationStatus: streem.api.GroupReservationStatus | undefined,
): ReservationBannerHandlerReturn => {
    return useMemo(() => {
        const hasValidReservation =
            groupReservationStatus &&
            [
                GroupReservationStatus.GROUP_RESERVATION_STATUS_MATCHED,
                GroupReservationStatus.GROUP_RESERVATION_STATUS_INITIATED,
            ].includes(groupReservationStatus);

        const shouldShowBanner = isReserved && hasValidReservation;
        const shouldClearBanner = !shouldShowBanner;

        return {
            shouldShowBanner,
            shouldClearBanner,
        };
    }, [isReserved, groupReservationStatus]);
};
